import React from 'react'

function Section3() {
  return (
    <div className='section3-container'>
        <div className='row'>     
            <div className='col-md-2 col-sm-2 col-6'>
                <ul>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                </ul>
            </div>
            <div className='col-md-2 col-sm-2 col-6'>
                <ul>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                </ul>
            </div>
            <div className='col-md-2 col-sm-2 col-6'>
                <ul>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                </ul>
            </div>
            <div className='col-md-2 col-sm-2 col-6'>
                <ul>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                </ul>
            </div>
            <div className='col-md-2 col-sm-2 col-6'>
                <ul>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                </ul>
            </div>
            <div className='col-md-2 col-sm-2 col-6'>
                <ul>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                    <li><a href={''}>Alabama MLS</a></li>
                </ul>
            </div>
        </div>
    </div>
  )
}

export default Section3